import {createReducer, difference, keys, find, keyBy, omit, get} from 'helpers';

export const collaborators = createReducer({}, {

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.collaborators);
    if (action.collaborators.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.collaborators, 'id'),
      }, removed);
    }
    return state;
  },

  COLLABORATORS_INVITE: (state, action) => {
    const user = find(state, { email: action.email });
    return {
      ...state,
      [get(user, 'id', '_' + action.email)]: {
        id: '_' + action.email,
        email: action.email,
        status: 'pending',
        ...user,
        lastInvited: action.timestamp,
      }
    }
  },

  COLLABORATORS_SET_NAME: (state, { user, name }) => {
    if (state[user.id]) {
      return {
        ...state,
        [user.id]: {
          ...state[user.id],
          name,
        }
      }
    }
    return state;
  },

  COLLABORATORS_REMOVE: (state, action) => {
    return omit(state, action.id);
  }

});
